import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

import ErrorComp from '@/components/Error.vue';
import LoadingComp from '@/components/Loading.vue';
import {useStorage} from '@/composables/storage';
import useContactDetailStore from '@/store/detailContact';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactDetails',
  setup(__props, { expose: __expose }) {

const detailContactStore = useContactDetailStore();
useStorage(detailContactStore, (contact, route) => (Array.isArray(route?.params.name) ? route?.params.name[0] : route?.params.name) || 'Ansprechpartner',
    (route) => {
      return {
        KundenNr: parseInt(Array.isArray(route.params.id) ? route.params.id[0] : route.params.id),
        AnsprechpartnerNr: parseInt(Array.isArray(route.params.contact_id) ?
         route.params.contact_id[0] :
         route.params.contact_id),
      };
    });

__expose({
  Error: ErrorComp,
  Loading: LoadingComp,
  detailContactStore,
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_Error = _resolveComponent("Error")!
  const _component_Loading = _resolveComponent("Loading")!

  return (!_unref(detailContactStore).loading && !_unref(detailContactStore).error && _unref(detailContactStore).data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_list, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, null, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-account")
                  ], undefined, true),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_subtitle, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(detailContactStore).data.Anrede), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(detailContactStore).data.fullName), 1)
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            }),
            (_unref(detailContactStore).data.Abteilung)
              ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(detailContactStore).data.Abteilung), 1)
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(detailContactStore).data.Position) + _toDisplayString(_unref(detailContactStore).data.AufgabenGebiet ? ` (${_unref(detailContactStore).data.AufgabenGebiet})` : ""), 1)
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(detailContactStore).data.AustrittDatum)
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 1,
                  class: "text-error"
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Ausgetreten")
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(detailContactStore).data.austrittsDatumParsed?.format("DD.MM.YYYY")), 1)
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_v_divider),
        _createVNode(_component_v_list, null, {
          default: _withCtx(() => [
            (_unref(detailContactStore).data.Strasse)
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 0,
                  link: "",
                  href: `https://maps.google.com/?saddr=My+Location&daddr=${_unref(detailContactStore).data.Strasse}, ${_unref(detailContactStore).data.Plz} ${_unref(detailContactStore).data.Ort}`,
                  target: "_blank"
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-map-marker")
                      ], undefined, true),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(detailContactStore).data.Strasse), 1)
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(`${_unref(detailContactStore).data.Plz} ${_unref(detailContactStore).data.Ort}`), 1)
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }, 8, ["href"]))
              : _createCommentVNode("", true)
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_v_divider),
        _createVNode(_component_v_list, null, {
          default: _withCtx(() => [
            (_unref(detailContactStore).data.Telefon1)
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 0,
                  link: "",
                  href: `tel: '${_unref(detailContactStore).data.Telefon1}'`
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-phone")
                      ], undefined, true),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(detailContactStore).data.Telefon1), 1)
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }, 8, ["href"]))
              : _createCommentVNode("", true),
            (_unref(detailContactStore).data.Telefon2)
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 1,
                  link: "",
                  href: `tel: '${_unref(detailContactStore).data.Telefon2}'`
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-cellphone")
                      ], undefined, true),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(detailContactStore).data.Telefon2), 1)
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }, 8, ["href"]))
              : _createCommentVNode("", true),
            (_unref(detailContactStore).data.Email)
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 2,
                  link: "",
                  href: `mailto: '${_unref(detailContactStore).data.Email}'`
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-at")
                      ], undefined, true),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(detailContactStore).data.Email), 1)
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }, 8, ["href"]))
              : _createCommentVNode("", true),
            (_unref(detailContactStore).data.Homepage)
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 3,
                  link: "",
                  href: `https://${_unref(detailContactStore).data.Homepage}`,
                  target: "_blank"
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-web")
                      ], undefined, true),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(detailContactStore).data.Homepage), 1)
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }, 8, ["href"]))
              : _createCommentVNode("", true)
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_v_divider),
        _createVNode(_component_v_list, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, {
              link: "",
              to: {
            name: 'contact_histories_list',
            params: { id: _ctx.$route.params.id },
            query: { ansprechpartner_nr: _ctx.$route.params.contact_id },
          }
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_avatar, {
                  size: "32px",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      color: "white",
                      size: "18px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-file-document-check")
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                })
              ]),
              append: _withCtx(() => [
                _createVNode(_component_v_list_item_action, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-arrow-right")
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Kontakte")
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            }, 8, ["to"])
          ], undefined, true),
          _: 1
        }),
        (_unref(detailContactStore).data.Info1 || _unref(detailContactStore).data.Info2)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_v_divider),
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  (_unref(detailContactStore).data.Info1)
                    ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-information-outline")
                            ], undefined, true),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(detailContactStore).data.Info1), 1)
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_unref(detailContactStore).data.Info2)
                    ? (_openBlock(), _createBlock(_component_v_list_item, { key: 1 }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-information-outline")
                            ], undefined, true),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(detailContactStore).data.Info2), 1)
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], undefined, true),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_v_btn, {
          position: "fixed",
          style: {"z-index":"1"},
          icon: "",
          location: "right bottom",
          class: "ma-3",
          to: {
        name: 'customer_contact_create',
        params: { id: _ctx.$route.params.id, contact_id: _ctx.$route.params.contact_id, name: _unref(detailContactStore).data.fullName },
      },
          color: "primary"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [
                _createTextVNode("mdi-pencil")
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }, 8, ["to"])
      ]))
    : (_unref(detailContactStore).error)
      ? (_openBlock(), _createBlock(_component_Error, {
          key: 1,
          module: _unref(detailContactStore).$id
        }, null, 8, ["module"]))
      : (_openBlock(), _createBlock(_component_Loading, { key: 2 }))
}
}

})